// utils/rolePermissions/menus.ts - utils/rolePermissions.ts split (sub-module menus)




// All available menus and features for role-based access control
export const ALL_MENUS = [
  // Main Menus
  { id: 'dashboard', name: 'Dasbor', category: 'menu', description: 'Dashboard Analytics' },

  // Produk Menu Group
  { id: 'products', name: 'Produk', category: 'menu', description: 'Product Management' },
  { id: 'product_list', name: 'Daftar Produk', category: 'submenu', description: 'Lihat dan kelola produk' },
  { id: 'form_list', name: 'Daftar Formulir', category: 'submenu', description: 'Lihat dan kelola formulir order' },
  { id: 'product_page', name: 'Product Page', category: 'submenu', description: 'Kelola product page untuk katalog' },
  { id: 'digital_products', name: 'Produk Digital', category: 'submenu', description: 'Kelola produk digital dan penjualan' },
  // Pesanan Menu Group
  { id: 'orders', name: 'Pesanan', category: 'menu', description: 'Order Management' },
  { id: 'order_list', name: 'Daftar Pesanan', category: 'submenu', description: 'Lihat dan kelola pesanan' },
  { id: 'abandoned_carts', name: 'Pesanan Tertinggal', category: 'submenu', description: 'Lihat keranjang yang ditinggalkan' },
  { id: 'digital_orders', name: 'Pesanan Digital', category: 'submenu', description: 'Lihat dan kelola pesanan produk digital' },

  // Pelanggan
  { id: 'customers', name: 'Pelanggan', category: 'menu', description: 'Customer Management' },

  // Laporan Menu Group
  { id: 'reports', name: 'Laporan', category: 'menu', description: 'Reports & Analytics' },
  { id: 'ad_reports', name: 'Laporan Iklan', category: 'submenu', description: 'Laporan performa iklan' },
  { id: 'cs_reports', name: 'Laporan CS', category: 'submenu', description: 'Laporan customer service' },
  { id: 'stock_reports', name: 'Laporan Stock', category: 'submenu', description: 'Laporan stok produk' },
  { id: 'finance_reports', name: 'Laporan Keuangan', category: 'submenu', description: 'Laporan keuangan' },
  { id: 'analytics_dashboard', name: 'Analytics Dashboard', category: 'submenu', description: 'Dashboard analytics lengkap' },

  // Penghasilan & Keuangan
  { id: 'earnings', name: 'Penghasilan', category: 'menu', description: 'Komisi & Penghasilan' },

  // WA Bot (Typebot)
  { id: 'wa_bot', name: 'WA Bot', category: 'menu', description: 'Setup Typebot & WA Bot integration' },
  { id: 'prospek', name: 'Prospek Chat', category: 'menu', description: 'Prospek/leads hasil chat WA Bot' },

  // Iklan
  { id: 'iklan_automation', name: 'Iklan & Automasi', category: 'menu', description: 'Automasi pembuatan iklan Meta' },

  // Pengaturan Menu Group
  { id: 'settings', name: 'Pengaturan', category: 'menu', description: 'System Settings' },
  { id: 'website_settings', name: 'Website', category: 'submenu', description: 'Konfigurasi website' },
  { id: 'brands', name: 'Merek', category: 'submenu', description: 'Kelola merek/brand' },
  { id: 'user_management', name: 'Pengguna', category: 'submenu', description: 'Kelola pengguna' },
  { id: 'role_management', name: 'Peran', category: 'submenu', description: 'Kelola izin role' },
  { id: 'cs_management', name: 'Customer Service', category: 'submenu', description: 'Kelola tim CS' },
  { id: 'vouchers', name: 'Voucher', category: 'submenu', description: 'Kelola voucher diskon' },
  { id: 'cuan_rank', name: 'CuanRank', category: 'submenu', description: 'Pengaturan ranking' },
  { id: 'tracking', name: 'Pelacakan', category: 'submenu', description: 'Pixel tracking' },
  { id: 'error_logs', name: 'Log Error', category: 'submenu', description: 'Monitor error sistem' },
  { id: 'performance_dashboard', name: 'Performa', category: 'submenu', description: 'Dashboard performa sistem' },

  // AI Tools
  { id: 'ai_landing_page', name: 'AI Landing Page', category: 'submenu', description: 'Buat landing page dengan AI' },

  { id: 'toko_online', name: 'Toko Online', category: 'submenu', description: 'Pengaturan dan pembuatan toko online' },
  { id: 'tiktok_download', name: 'Download TikTok', category: 'submenu', description: 'Unduh video TikTok tanpa watermark' },

  // Hidden/Legacy (for backward compatibility)
  { id: 'deletion_requests', name: 'Permintaan Hapus', category: 'submenu', description: 'Permintaan penghapusan data' },
  { id: 'feature_requests', name: 'Pengajuan Fitur', category: 'submenu', description: 'Kelola pengajuan fitur & komplain (Super Admin Only)' },
  { id: 'cek_ongkir', name: 'Cek Ongkir', category: 'submenu', description: 'Cek tarif pengiriman real-time' },

  // Pengiriman
  { id: 'everpro', name: 'Everpro', category: 'menu', description: 'Dashboard pengiriman Everpro (saldo, akun, riwayat)' },
  { id: 'mengantar', name: 'Mengantar', category: 'menu', description: 'Riwayat & detail pengiriman Mengantar' },
  { id: 'lincah', name: 'Lincah', category: 'menu', description: 'Pengiriman Lincah (segera hadir)' },
  { id: 'cod_guard', name: 'COD Guard', category: 'menu', description: 'Pantau paket COD — cegah retur & RTS' },
] as const;

